<template>
  <div>
    <h3>Safe Milksharing</h3>
    <br />
    <br />
    <div class="imageListContainer">
      <ImageContainer size="lg" hyperLinkTo="/shareables/FourPillars.png" imagePath="/shareables/FourPillars.png" subTitle="Download Flyer PDF" class="milkContainer"/>
      <ImageContainer size="lg" hyperLinkTo="/shareables/InformedChoice.png" imagePath="/shareables/InformedChoice.png" subTitle="Download Flyer PDF" class="milkContainer"/>
      <ImageContainer size="lg" hyperLinkTo="/shareables/Storage.jpg" imagePath="/shareables/Storage.jpg" subTitle="Download Flyer PDF" class="milkContainer"/>
      <ImageContainer size="lg" hyperLinkTo="/shareables/ContactedDonorNextSteps.png" imagePath="/shareables/ContactedDonorNextSteps.png" subTitle="Download Flyer PDF" class="milkContainer"/>
      <ImageContainer size="lg" hyperLinkTo="/shareables/FriendsAndRelatives.png" imagePath="/shareables/FriendsAndRelatives.png" subTitle="Download Flyer PDF" class="milkContainer"/>
      <ImageContainer size="lg" hyperLinkTo="/shareables/HowToFeedDonorMilk.png" imagePath="/shareables/HowToFeedDonorMilk.png" subTitle="Download Flyer PDF" class="milkContainer"/>
      <ImageContainer size="lg" hyperLinkTo="/shareables/ProperCareAndTimelyUse.png" imagePath="/shareables/ProperCareAndTimelyUse.png" subTitle="Download Flyer PDF" class="milkContainer"/>
      <ImageContainer size="lg" hyperLinkTo="/shareables/HomePasteurizationOfBreastmilk.png" imagePath="/shareables/HomePasteurizationOfBreastmilk.png" subTitle="Download Flyer PDF" class="milkContainer"/>
      <ImageContainer size="lg" hyperLinkTo="/shareables/WhySomeoneShouldNotDonate.png" imagePath="/shareables/WhySomeoneShouldNotDonate.png" subTitle="Download Flyer PDF" class="milkContainer"/>
      <ImageContainer size="lg" hyperLinkTo="/shareables/WhySomeoneShouldNotRequest.png" imagePath="/shareables/WhySomeoneShouldNotRequest.png" subTitle="Download Flyer PDF" class="milkContainer"/>
    </div>
    <br />
    <p>Non-commerce use only</p>
    <p>©Eats on Feets™</p>
  </div>
</template>

<script>
import ImageContainer from '../components/ImageContainer'
export default {
  name: 'ResourceSafeMilksharing',
  components: { ImageContainer },
  metaInfo: {
    title: 'Eats On Feets - Resources - Safe Milksharing',
    titleTemplate: null
  }
}
</script>

<style lang="scss" scoped>
.milkContainer{
 max-width: 330px;
}
</style>
